import { AiProcessStepBlobKind } from 'constants/aiProcessRuns';

export const StepViewModeEnum = {
  TOOL_CALLS: 'toolCalls',
  TRANSCRIPT: 'transcript',
  RAW: 'raw',
};

export const RAW_TABS = [
  { value: AiProcessStepBlobKind.INPUT, label: 'Input' },
  { value: AiProcessStepBlobKind.OUTPUT, label: 'Output' },
  { value: AiProcessStepBlobKind.ERROR, label: 'Error' },
];
